import React from 'react'
import { asText } from '@prismicio/helpers'
import { Slice } from '@prismicio/types'
import { Content } from '@prismicio/client'
import classNames from 'classnames'

export type TableSliceProps = {
  slice: Slice
  className?: string
}

export const TableSlice = ({ className = '', slice }: TableSliceProps) => {
  if (slice.slice_type !== 'table') {
    return null
  }

  const tableSlice = slice as Content.TableSlice
  const tableData = tableSlice.primary.content

  if (!tableData || !tableData.body || !Array.isArray(tableData.body.rows)) {
    return null
  }

  const rows = tableData.body.rows

  return (
    <div className='d-flex justify-content-md-center mb-8'>
      <div className='col-lg-10 col-12'>
        <div className='px-2'>
          <div className={`table-responsive mb-6`}>
            <table className={`table table-bordered ${className}`}>
              <tbody>
                {rows.map((row: any, rowIndex: number) => {
                  if (!row.cells || !Array.isArray(row.cells)) {
                    return null
                  }

                  return (
                    <tr key={row.key || rowIndex}>
                      {row.cells.map((cell: any, cellIndex: number) => {
                        const isHeader = rowIndex === 0
                        const Tag = isHeader ? 'th' : 'td'
                        const cellText = asText(cell.content) || ''
                        const hasStrongSpans = cell.content?.some(
                          (paragraph: any) =>
                            paragraph.spans?.some(
                              (span: any) => span.type === 'strong',
                            ),
                        )
                        const isFirstColumn = cellIndex === 0

                        return (
                          <Tag
                            key={cell.key || cellIndex}
                            className={classNames('p-4 text-start ', {
                              'bg-fuchsia2 text-white':
                                isFirstColumn && !isHeader,
                              'bg-purple7 text-white': isHeader,
                              'fw-bold': isHeader || hasStrongSpans,
                            })}
                          >
                            {cellText}
                          </Tag>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
